export type PlanKey = 'free' | 'lite' | 'standard' | 'forever';

export interface PlanPrice {
  key: string;
  plan_key: PlanKey;
  amount: number;
  currency: string;
  interval: 'month' | 'year';
}

export interface PlanSummary {
  plan_key: PlanKey;
  price_key: string | null;
  pending_plan_key: PlanKey | null;
  pending_change_at: string | null;
  access_ends_at: string | null;
  subscription_status: string | null;
  prices: PlanPrice[];
}

export interface EmbeddedCheckoutSession {
  client_secret: string;
  publishable_key: string;
}

interface PlanSelectionResult {
  checkout?: EmbeddedCheckoutSession;
  url?: string;
  message?: string;
}

export const APIfetchPlans = async (): Promise<PlanSummary> => {
  const response = await window.axios.get<PlanSummary>('/api/plans');
  return response.data;
};

export const APIselectPlan = async (priceKey: string): Promise<PlanSelectionResult> => {
  const response = await window.axios.post<PlanSelectionResult>('/api/plans', { price_key: priceKey });
  return response.data;
};

export const APIopenBillingPortal = async (): Promise<{ url: string }> => {
  const response = await window.axios.post<{ url: string }>('/api/plans/portal');
  return response.data;
};
